export function invoices(state=[], action) {
    switch (action.type) {
            case 'UPDATE_INVOICES':
                return action.invoices
            default:
                return state
    }
}